<template>
  <div class="user-detail">
    <div class="back-btn" @click="goBack">← 返回列表</div>
    
    <div class="detail-header">
      <h2>用户详情</h2>
    </div>

    <div class="detail-section">
      <h3>基本信息</h3>
      <div class="info-grid">
        <div class="info-item">
          <label>用户ID</label>
          <span>{{ userDetail.id }}</span>
        </div>
        <div class="info-item">
          <label>用户名</label>
          <span>{{ userDetail.name }}</span>
        </div>
        <div class="info-item">
          <label>昵称</label>
          <span>{{ userDetail.nickname || '-' }}</span>
        </div>
        <div class="info-item">
          <label>姓名</label>
          <span>{{ userDetail.real_name || '-' }}</span>
        </div>
        <div class="info-item">
          <label>头像</label>
          <img v-if="userDetail.avatar" :src="userDetail.avatar" alt="头像" class="avatar-img" />
          <span v-else>-</span>
        </div>
        <div class="info-item">
          <label>性别</label>
          <span>{{ userDetail.gender === 1 ? '男' : userDetail.gender === 2 ? '女' : '未知' }}</span>
        </div>
        <div class="info-item">
          <label>unionid</label>
          <span>{{ userDetail.unionid || '-' }}</span>
        </div>
        <div class="info-item">
          <label>手机号</label>
          <span>{{ userDetail.phone }}</span>
        </div>
        <div class="info-item">
          <label>角色</label>
          <div class="role-tags">
            <span
              v-for="code in roleList(userDetail.roles)"
              :key="code"
              class="role-tag"
              :class="'role-' + code"
            >{{ roleName(code) }}</span>
            <span v-if="!roleList(userDetail.roles).length" class="role-tag role-user">普通用户</span>
          </div>
        </div>
        <div class="info-item">
          <label>订单数</label>
          <span>{{ userDetail.orderCount }}</span>
        </div>
        <div class="info-item">
          <label>用户钱包余额</label>
          <span>{{ userDetail.wallet ? (userDetail.wallet.balance / 100).toFixed(2) : '0.00' }}</span>
        </div>
        <div class="info-item">
          <label>累计充值</label>
          <span>{{ userDetail.wallet ? (userDetail.wallet.total_recharge / 100).toFixed(2) : '0.00' }}</span>
        </div>
        <div class="info-item">
          <label>累计消费</label>
          <span>{{ userDetail.wallet ? (userDetail.wallet.total_consume / 100).toFixed(2) : '0.00' }}</span>
        </div>
        <div class="info-item">
          <label>累计退款</label>
          <span>{{ userDetail.wallet ? (userDetail.wallet.total_refund / 100).toFixed(2) : '0.00' }}</span>
        </div>
        <div class="info-item">
          <label>注册时间</label>
          <span>{{ formatDateShort(userDetail.created_at) }}</span>
        </div>
        <div class="info-item">
          <label>状态</label>
          <span :class="['status', userDetail.status === 1 ? 'is-on' : 'is-off']">{{ userDetail.status === 1 ? '正常' : '禁用' }}</span>
        </div>
      </div>
    </div>

    <div class="detail-section">
      <h3>操作</h3>
      <div class="action-buttons">
        <button @click="toggleStatus" :class="userDetail.status === 1 ? 'btn-danger' : 'btn-success'">
          {{ userDetail.status === 1 ? '禁用用户' : '启用用户' }}
        </button>
      </div>
    </div>

    <div class="detail-section">
      <div class="section-header">
        <h3>用户钱包流水</h3>
        <router-link v-if="userDetail.id" :to="`/finance/transactions?user_id=${userDetail.id}`" class="btn-link">查看全部角色钱包</router-link>
      </div>
      <transaction-list :user-id="userDetail.id" :role-code="'user'" />
    </div>
  </div>
</template>

<script>
import { getUserDetail, updateUserStatus } from '@/api/users'
import { formatDateShort } from '@/utils/date'
import TransactionList from '@/components/TransactionList.vue'
export default {
  name: 'UserDetail',
  components: {
    TransactionList
  },
  data() {
    return {
      userDetail: {}
    }
  },
  mounted() {
    this.loadUserDetail()
  },
  methods: {
    formatDateShort,
    roleList(roles = []) {
      return Array.isArray(roles) ? roles : []
    },
    roleName(code) {
      // 注意:后端 Role 模型的普通用户 code 是 'user'(非 'normal')
      const map = {
        user: '普通用户',
        admin_super: '超级管理员',
        community_agent: '小区代理',
        runner: '跑手',
        shop_referrer: '店家推广人',
        runner_referrer: '跑手推广人',
        platform: '平台',
        shop: '店家'
      }
      return map[code] || code
    },
    goBack() {
      this.$router.push('/user/users')
    },
    async loadUserDetail() {
      try {
        const userId = this.$route.params.id
        const response = await getUserDetail(userId)
        if (response) {
          this.userDetail = response.data || response
        }
      } catch (error) {
      }
    },
    async toggleStatus() {
      const action = this.userDetail.status === 1 ? '禁用' : '启用'
      if (confirm(`确定要${action}用户 ${this.userDetail.name} 吗？`)) {
        try {
          const newStatus = this.userDetail.status === 1 ? 0 : 1
          await updateUserStatus(this.userDetail.id, newStatus)
          this.userDetail.status = newStatus
        } catch (error) {
        }
      }
    }
  }
}
</script>

<style scoped>
.user-detail {
  padding: 20px;
}

.back-btn {
  color: #3498db;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 14px;
}

.detail-header {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
}

.detail-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.detail-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.detail-section h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.section-header h3 {
  margin: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.btn-link {
  align-self: flex-start;
  margin-top: 8px;
  padding: 4px 10px;
  background: transparent;
  color: #3498db;
  border: 1px solid #3498db;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  text-decoration: none;
}

.btn-link:hover {
  background: #3498db;
  color: #fff;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-item label {
  font-size: 13px;
  color: #999;
  margin-bottom: 5px;
}

.info-item span {
  font-size: 14px;
  color: #333;
}

.avatar-img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #eee;
}

.status {
  padding: 4px 0;
  border-radius: 20px;
  font-size: 12px;
}

.status.is-on { background: #e8f5e9; color: #2ecc71; }
.status.is-off { background: #ffebee; color: #e74c3c; }

.role-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.role-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 1.5;
  white-space: nowrap;
}

.role-tags .role-user { background: #eef2f7; color: #5b6b7f; }
.role-tags .role-admin_super { background: #eef2f7; color: #5b6b7f; }
.role-tags .role-community_agent { background: #eef2f7; color: #5b6b7f; }
.role-tags .role-runner { background: #eef2f7; color: #5b6b7f; }
.role-tags .role-shop_referrer { background: #eef2f7; color: #5b6b7f; }
.role-tags .role-runner_referrer { background: #eef2f7; color: #5b6b7f; }
.role-tags .role-platform { background: #eef2f7; color: #5b6b7f; }
.role-tags .role-shop { background: #eef2f7; color: #5b6b7f; }

.action-buttons {
  display: flex;
  gap: 15px;
}

.action-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-danger {
  background: #e74c3c;
  color: #fff;
}

.btn-success {
  background: #2ecc71;
  color: #fff;
}
</style>
